<template>
  <div>
    <form enctype="multipart/form-data">
      <div class="dropbox" :style="getstyle()" @drop="drop($event)">
        <input
          type="file"
          :multiple="multiple"
          :name="type"
          :disabled="saving"
          @change="filesChange($event.target.files); fileCount=$event.target.files.length"
          :accept="accept"
          class="input-file d-none"
        >
        <template v-if="!this.imageSrc">
            <div>
                <p v-if="!saving" v-text="_trans('Drag your image here')"></p>
                <p v-if="!saving" v-text="_trans('or click to browse')"></p>
                <p v-else v-text="_trans('Uploading image...')"></p>
            </div>
        </template>
      </div>
    </form>
  </div>
</template>

<script>

import { Dau, bus } from '@store/dau'

export default {
    props:{
        name:{ type:String, default:'' },
        newname: { type:String, default:'' },
        type: { type:String, default:'GEN' },
        catalog: { type:String, default:''},
        dim: String,
        height: { type:String, default:"100px" },
        images: { type:Boolean, default: false },
        multiple: { type:Boolean, default: false },
        image: String
    },
    computed: {
        accept() {
            return this.images?"image/*":"*/*";
        },
        prj() {
            return this.$store.state.project;
        }
    },
    data() {
        return {
            saving: false,
            imageSrc: this.images
        }
    },
    methods: {
        getstyle() {
            return {
                height: this.height,
                backgroundImage: this.imageSrc?("url("+ this.imageSrc +")"):""
            };
        },
        drop(e) {
            if (e.dataTransfer) {
                if (e.dataTransfer.files && e.dataTransfer.files.length)  {
                    this.filesChange(e.dataTransfer.files);
                } else {
                    let aa=e.dataTransfer.getData("text/html");
                    if (aa && aa.substring(0,4) === "<img")     {
                        let div = document.createElement("div")
                        div.innerHTML = aa;
                        let s = div.firstChild.getAttribute("src");
                        if (s !== null)  {
                            this.filesChange([],s);
                        }
                    }
                }
                this.$emit('drop',res)
            }
        },
        filesChange(fileList, linklist) {
            this.saving=true;
            let imageUploaded = new File([fileList[0]], 'tmp.jpg', { type: 'image/jpeg' });
            let imageSrc = (window.URL ? URL : webkitURL).createObjectURL(imageUploaded);
            this.imageSrc = imageSrc;
            this.$emit('loaded', imageSrc);

            /*Dau.uploadFiles(fileList, this.prj.id,
                res => {
                    this.saving = false;
                    Dau.downloadReq(res.filename, this.prj.id, 
                        res => {
                            let imageUploaded = new File([res], 'tmp.jpg', { type: 'image/jpeg' });
                            let imageSrc = (window.URL ? URL : webkitURL).createObjectURL(imageUploaded);
                            this.imageSrc = imageSrc;
                            this.$emit('loaded', imageSrc);
                        },
                        err => {
                            console.error(err);
                        });
                },
                err => {
                    console.error(err);
                    this.saving=false;
                    this.$emit('error',err);
                });*/
        }
    }
}
</script>
<style scoped lang="scss">
  .dropbox {
    outline: 2px dashed $gray-light;
    color: $info;
    padding: 10px 10px;
    position: relative;
    cursor: pointer;
    background-color: lighten($color-0, 10);
    background-repeat: no-repeat;
    background-size: contain;
    margin-bottom: 10px;
    background-position: 50% 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 10px;

    .input-file {
      opacity: 0;
      width: 100%;
      height: 100px;
      position: absolute;
      cursor: pointer;
    }

    p {
      text-align: center;
      padding: 10px 0;
    }

    &:hover {
      color: $color-0;
      outline: 2px dashed $primary;
    }
  }

  p {
    margin: auto;
  }
</style>



// WEBPACK FOOTER //
// src/_eng/globals/dupload.vue